module.exports = __webpack_public_path__ + "img/jribeiro.7133c568.png";